/* =========================================================
   LUX MORTIS — Story modal
   Loaded from more than one section (finish rows, modal), so it
   guards against running its setup twice on the same page.

   Delegated on document so it works no matter how many
   section-luxmortis-finish instances (or fragrance blocks) exist.
   Each plaque's detail content lives in a <template> next to it;
   this script only ever reads it at click time — nothing here is
   hard-coded, so the popup always reflects whatever the merchant
   configured for that specific block.
   ========================================================= */
(function () {
  'use strict';

  if (window.luxMortisLandingJsLoaded) return;
  window.luxMortisLandingJsLoaded = true;

  var backdrop = document.getElementById('luxmModalBackdrop');
  if (!backdrop) return;

  var modal = backdrop.querySelector('.luxm-modal');
  var closeBtn = document.getElementById('luxmModalClose');
  var finishEl = document.getElementById('luxmModalFinish');
  var nameEl = document.getElementById('luxmModalName');
  var storyEl = document.getElementById('luxmModalStory');
  var notesEl = document.getElementById('luxmModalNotes');
  var lastFocused = null;

  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function openModal(trigger) {
    var targetId = trigger.getAttribute('data-luxm-target');
    var source = targetId ? document.getElementById(targetId) : null;
    if (!source) return;

    finishEl.innerHTML = source.dataset.finishTag || '';
    nameEl.textContent = source.dataset.name || '';
    storyEl.textContent = source.dataset.story || '';
    notesEl.innerHTML = source.dataset.notes || '';

    lastFocused = trigger;
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-luxm-plaque-trigger]');
    if (trigger) {
      openModal(trigger);
    }
  });

  closeBtn.addEventListener('click', closeModal);

  backdrop.addEventListener('click', function (event) {
    if (event.target === backdrop) closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (!backdrop.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      var items = modal.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
